export const bronzeMedal = (
    <svg
  width={72}
  height={90}
  viewBox="0 0 72 90"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M56.7751 89.9992L60.5094 79.1021L71.5811 81.5851L61.1737 63.5469L46.3677 71.961L56.7751 89.9992Z"
    fill="url(#paint0_linear_9576_95098)"
  />
  <path
    d="M15.387 89.7472L11.655 78.8501L0.581055 81.3332L10.9885 63.2949L25.7945 71.709L15.387 89.7472Z"
    fill="url(#paint1_linear_9576_95098)"
  />
  <path
    d="M1.05762 22.3071V56.8786C1.05762 58.672 2.02123 60.3288 3.58574 61.2266L33.7527 78.5123C35.3172 79.4101 37.2466 79.4101 38.8111 78.5123L68.9781 61.2266C70.5426 60.3288 71.5062 58.672 71.5062 56.8786V22.3071C71.5062 20.5137 70.5426 18.8569 68.9781 17.9591L38.8111 0.673344C37.2466 -0.224448 35.3172 -0.224448 33.7527 0.673344L3.58574 17.9591C2.02123 18.8569 1.05762 20.5137 1.05762 22.3071Z"
    fill="url(#paint2_linear_9576_95098)"
  />
  <path
    d="M7.19434 25.8268V53.3655C7.19434 55.159 8.15795 56.8158 9.72246 57.7136L33.7538 71.4819C35.3183 72.3796 37.2477 72.3796 38.8122 71.4819L62.8435 57.7136C64.408 56.8158 65.3716 55.159 65.3716 53.3655V25.8268C65.3716 24.0333 64.408 22.3766 62.8435 21.4788L38.8122 7.71045C37.2477 6.81266 35.3183 6.81266 33.7538 7.71045L9.72246 21.4788C8.15795 22.3766 7.19434 24.0333 7.19434 25.8268Z"
    fill="url(#paint3_linear_9576_95098)"
  />
  <path
    d="M8.72754 26.6987V52.4831C8.72754 54.2765 9.69115 55.9333 11.2557 56.8311L33.7552 69.7233C35.3197 70.6211 37.2492 70.6211 38.8137 69.7233L61.3133 56.8311C62.8778 55.9333 63.8414 54.2765 63.8414 52.4831V26.6987C63.8414 24.9053 62.8778 23.2485 61.3133 22.3507L38.8137 9.4585C37.2492 8.56071 35.3197 8.56071 33.7552 9.4585L11.2557 22.3507C9.69115 23.2485 8.72754 24.9053 8.72754 26.6987Z"
    fill="url(#paint4_linear_9576_95098)"
  />
  <path
    d="M52.7128 56.4704C62.0174 47.236 62.0174 32.264 52.7128 23.0296C43.4082 13.7952 28.3225 13.7952 19.0179 23.0296C9.71328 32.264 9.71328 47.236 19.0179 56.4704C28.3225 65.7048 43.4082 65.7048 52.7128 56.4704Z"
    fill="url(#paint5_radial_9576_95098)"
  />
  <path
    d="M32.0062 34.0469H18.8281L36.0814 39.6093L32.0062 34.0469Z"
    fill="#E4C0A3"
  />
  <path
    d="M36.082 39.6055L46.743 54.1696L42.67 41.7307L36.082 39.6055Z"
    fill="#C68C65"
  />
  <path
    d="M25.418 54.1696L36.0811 46.482V39.6055L25.418 54.1696Z"
    fill="#C68C65"
  />
  <path
    d="M53.3331 34.0469H40.1528L36.082 39.6093L53.3331 34.0469Z"
    fill="#C68C65"
  />
  <path
    d="M36.082 46.482L46.743 54.1696L36.082 39.6055V46.482Z"
    fill="#E4C0A3"
  />
  <path
    d="M36.0811 39.6055L29.4909 41.7307L25.418 54.1696L36.0811 39.6055Z"
    fill="#E4C0A3"
  />
  <path
    d="M32.0063 34.0427L36.0815 39.6051V21.6016L32.0063 34.0427Z"
    fill="#C68C65"
  />
  <path
    d="M36.082 21.6016V39.6051L40.1528 34.0427L36.082 21.6016Z"
    fill="#E4C0A3"
  />
  <path
    d="M36.0814 39.6093L18.8281 34.0469L29.4912 41.7345L36.0814 39.6093Z"
    fill="#C68C65"
  />
  <path
    d="M36.082 39.6093L42.67 41.7345L53.3331 34.0469L36.082 39.6093Z"
    fill="#E4C0A3"
  />
  <path
    d="M20.5972 21.156C20.5999 19.6242 19.3508 18.3802 17.8074 18.3776C16.2639 18.3749 15.0105 19.6145 15.0078 21.1463C15.0051 22.6781 16.2542 23.9221 17.7976 23.9248C19.3411 23.9274 20.5945 22.6878 20.5972 21.156Z"
    fill="url(#paint6_radial_9576_95098)"
  />
  <path
    d="M17.8036 25.1219C17.8036 22.9273 16.0096 21.1469 13.7983 21.1469C16.0118 21.1469 17.8036 19.3665 17.8036 17.1719C17.8036 19.3665 19.5975 21.1469 21.8088 21.1469C19.5953 21.1469 17.8036 22.9273 17.8036 25.1219Z"
    fill="white"
  />
  <path
    d="M45.0398 68.1886C45.042 67.1406 44.1878 66.2893 43.1318 66.2871C42.0759 66.2849 41.2181 67.1327 41.2159 68.1806C41.2137 69.2286 42.0679 70.0799 43.1238 70.0821C44.1798 70.0843 45.0376 69.2365 45.0398 68.1886Z"
    fill="url(#paint7_radial_9576_95098)"
  />
  <path
    d="M43.127 70.906C43.127 69.4032 41.899 68.1845 40.3848 68.1845C41.899 68.1845 43.127 66.9657 43.127 65.4629C43.127 66.9657 44.355 68.1845 45.8693 68.1845C44.355 68.1845 43.127 69.4032 43.127 70.906Z"
    fill="white"
  />
  <path
    d="M56.1718 22.1767C58.3319 22.1741 60.0809 20.4341 60.0783 18.2902C60.0756 16.1464 58.3224 14.4106 56.1622 14.4132C54.0021 14.4158 52.2531 16.1559 52.2558 18.2997C52.2584 20.4436 54.0117 22.1794 56.1718 22.1767Z"
    fill="url(#paint8_radial_9576_95098)"
  />
  <path
    d="M56.1701 23.8481C56.1701 20.7752 53.6595 18.2835 50.561 18.2835C53.6595 18.2835 56.1701 15.7897 56.1701 12.7168C56.1701 15.7897 58.6807 18.2835 61.7792 18.2835C58.6807 18.2835 56.1701 20.7774 56.1701 23.8503V23.8481Z"
    fill="white"
  />
  <defs>
    <linearGradient
      id="paint0_linear_9576_95098"
      x1="66.5837"
      y1="85.7682"
      x2="51.5249"
      y2="67.6869"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor="#D9B395" />
      <stop offset={1} stopColor="#743B23" />
    </linearGradient>
    <linearGradient
      id="paint1_linear_9576_95098"
      x1="5.57704"
      y1="85.5061"
      x2="20.6348"
      y2="67.4267"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor="#D9B395" />
      <stop offset={1} stopColor="#743B23" />
    </linearGradient>
    <linearGradient
      id="paint2_linear_9576_95098"
      x1="36.283"
      y1="79.1846"
      x2="36.283"
      y2="0.00108553"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor="#AE704F" />
      <stop offset="0.5" stopColor="#DCB698" />
      <stop offset={1} stopColor="#E4C0A3" />
    </linearGradient>
    <linearGradient
      id="paint3_linear_9576_95098"
      x1="25.6341"
      y1="68.6302"
      x2="46.6487"
      y2="10.4598"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor="#9D654B" />
      <stop offset="0.5" stopColor="#E9C9BA" />
      <stop offset={1} stopColor="#8C5339" />
    </linearGradient>
    <linearGradient
      id="paint4_linear_9576_95098"
      x1="36.2834"
      y1="70.3934"
      x2="36.2834"
      y2="8.78624"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor="#82452B" />
      <stop offset={1} stopColor="#C2876A" />
    </linearGradient>
    <radialGradient
      id="paint5_radial_9576_95098"
      cx={0}
      cy={0}
      r={1}
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(35.8653 39.7506) scale(23.8259 23.6462)"
    >
      <stop stopColor="#591F25" />
      <stop offset="0.826923" stopColor="#C2876A" stopOpacity="0.15" />
      <stop offset="0.975962" stopColor="#975B40" stopOpacity="0.07" />
    </radialGradient>
    <radialGradient
      id="paint6_radial_9576_95098"
      cx={0}
      cy={0}
      r={1}
      gradientTransform="matrix(0.00832096 -2.78328 2.80444 0.00825819 17.9745 20.7958)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0.0384615" stopColor="white" stopOpacity="0.2" />
      <stop offset={1} stopColor="#C2876A" stopOpacity="0.2" />
    </radialGradient>
    <radialGradient
      id="paint7_radial_9576_95098"
      cx={0}
      cy={0}
      r={1}
      gradientTransform="matrix(0.00636232 -1.90412 1.91859 0.00631432 43.2456 67.9415)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0.0384615" stopColor="white" stopOpacity="0.2" />
      <stop offset={1} stopColor="#C2876A" stopOpacity="0.2" />
    </radialGradient>
    <radialGradient
      id="paint8_radial_9576_95098"
      cx={0}
      cy={0}
      r={1}
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(56.6688 18.5324) scale(3.92492 3.89531)"
    >
      <stop offset="0.0384615" stopColor="white" stopOpacity="0.2" />
      <stop offset={1} stopColor="#C2876A" stopOpacity="0.2" />
    </radialGradient>
  </defs>
</svg>
)


export const silverMedal = (
<svg
  width={72}
  height={85}
  viewBox="0 0 72 85"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M53.0358 84.5839L56.5083 74.3716L66.804 76.6981L57.126 59.7988L43.3579 67.6826L53.0358 84.5839Z"
    fill="url(#paint0_linear_9576_94306)"
  />
  <path
    d="M14.5489 84.3417L11.0784 74.1294L0.780762 76.4559L10.4587 59.5566L24.2268 67.4404L14.5489 84.3417Z"
    fill="url(#paint1_linear_9576_94306)"
  />
  <path
    d="M1.22363 21.157V53.5494C1.22363 55.2298 2.1197 56.7822 3.57454 57.6234L31.6269 73.8196C33.0817 74.6608 34.8759 74.6608 36.3307 73.8196L64.3831 57.6234C65.8379 56.7822 66.734 55.2298 66.734 53.5494V21.157C66.734 19.4766 65.8379 17.9242 64.3831 17.083L36.3307 0.886763C34.8759 0.0455582 33.0817 0.0455582 31.6269 0.886763L3.57454 17.083C2.1197 17.9242 1.22363 19.4766 1.22363 21.157Z"
    fill="url(#paint2_linear_9576_94306)"
  />
  <path
    d="M6.93018 24.4491V50.2522C6.93018 51.9325 7.82624 53.4849 9.28108 54.3261L31.6279 67.2266C33.0827 68.0678 34.8769 68.0678 36.3317 67.2266L58.6785 54.3261C60.1333 53.4849 61.0294 51.9325 61.0294 50.2522V24.4491C61.0294 22.7687 60.1333 21.2164 58.6785 20.3752L36.3317 7.47465C34.8769 6.63345 33.0827 6.63345 31.6279 7.47465L9.28108 20.3752C7.82624 21.2164 6.93018 22.7687 6.93018 24.4491Z"
    fill="url(#paint3_linear_9576_94306)"
  />
  <path
    d="M8.35596 25.2728V49.432C8.35596 51.1124 9.25202 52.6647 10.7069 53.506L31.6293 65.5856C33.0841 66.4268 34.8783 66.4268 36.3331 65.5856L57.2556 53.506C58.7104 52.6647 59.6065 51.1124 59.6065 49.432V25.2728C59.6065 23.5924 58.7104 22.04 57.2556 21.1988L36.3331 9.11918C34.8783 8.27798 33.0841 8.27798 31.6293 9.11918L10.7069 21.1988C9.25202 22.04 8.35596 23.5924 8.35596 25.2728Z"
    fill="url(#paint4_linear_9576_94306)"
  />
  <path
    d="M34.0205 60.5811C46.2568 60.5811 56.1763 50.6616 56.1763 38.4253C56.1763 26.189 46.2568 16.2695 34.0205 16.2695C21.7842 16.2695 11.8647 26.189 11.8647 38.4253C11.8647 50.6616 21.7842 60.5811 34.0205 60.5811Z"
    fill="url(#paint5_radial_9576_94306)"
  />
  <path
    d="M57.6981 20.9304C59.7068 20.9304 61.3352 19.302 61.3352 17.2933C61.3352 15.2846 59.7068 13.6562 57.6981 13.6562C55.6894 13.6562 54.061 15.2846 54.061 17.2933C54.061 19.302 55.6894 20.9304 57.6981 20.9304Z"
    fill="url(#paint6_radial_9576_94306)"
  />
  <path
    d="M57.6978 22.5079C57.6978 19.6287 55.3632 17.294 52.4819 17.294C55.3632 17.294 57.6978 14.9573 57.6978 12.0781C57.6978 14.9573 60.0325 17.292 62.9137 17.292C60.0325 17.292 57.6978 19.6287 57.6978 22.5079Z"
    fill="white"
  />
  <path
    d="M12.1981 62.2037C13.18 62.1937 13.9678 61.3897 13.9579 60.4078C13.948 59.426 13.144 58.6381 12.1621 58.648C11.1802 58.658 10.3923 59.462 10.4023 60.4438C10.4122 61.4257 11.2162 62.2136 12.1981 62.2037Z"
    fill="url(#paint7_radial_9576_94306)"
  />
  <path
    d="M12.198 62.9672C12.198 61.5591 11.0561 60.4172 9.64795 60.4172C11.0561 60.4172 12.198 59.2753 12.198 57.8672C12.198 59.2753 13.3399 60.4172 14.748 60.4172C13.3399 60.4172 12.198 61.5591 12.198 62.9672Z"
    fill="white"
  />
  <path
    d="M30.0034 32.1465H17.749L33.7929 37.3603L30.0034 32.1465Z"
    fill="#6A7E88"
  />
  <path
    d="M33.7935 37.3652L43.7071 51.0114L39.9196 39.3545L33.7935 37.3652Z"
    fill="#9AB2BE"
  />
  <path
    d="M23.877 51.0114L33.7926 43.8084V37.3652L23.877 51.0114Z"
    fill="#9AB2BE"
  />
  <path
    d="M49.8353 32.1465H37.5789L33.7935 37.3603L49.8353 32.1465Z"
    fill="#9AB2BE"
  />
  <path
    d="M33.7935 43.8084L43.7071 51.0114L33.7935 37.3652V43.8084Z"
    fill="#6A7E88"
  />
  <path
    d="M33.7926 37.3652L27.6644 39.3545L23.877 51.0114L33.7926 37.3652Z"
    fill="#6A7E88"
  />
  <path
    d="M30.0034 32.151L33.7929 37.3649V20.4961L30.0034 32.151Z"
    fill="#9AB2BE"
  />
  <path
    d="M33.7935 20.4961V37.3649L37.5789 32.151L33.7935 20.4961Z"
    fill="#6A7E88"
  />
  <path
    d="M33.7929 37.3603L17.749 32.1465L27.6647 39.3496L33.7929 37.3603Z"
    fill="#9AB2BE"
  />
  <path
    d="M33.7935 37.3603L39.9196 39.3496L49.8353 32.1465L33.7935 37.3603Z"
    fill="#6A7E88"
  />
  <path
    d="M19.3902 20.0808C19.4015 18.6456 18.2471 17.4729 16.8119 17.4617C15.3767 17.4504 14.204 18.6047 14.1928 20.04C14.1815 21.4752 15.3359 22.6478 16.7711 22.6591C18.2063 22.6704 19.3789 21.516 19.3902 20.0808Z"
    fill="url(#paint8_radial_9576_94306)"
  />
  <path
    d="M16.7958 23.7946C16.7958 21.7383 15.1276 20.0702 13.0713 20.0702C15.1296 20.0702 16.7958 18.402 16.7958 16.3457C16.7958 18.402 18.4639 20.0702 20.5202 20.0702C18.4619 20.0702 16.7958 21.7383 16.7958 23.7946Z"
    fill="white"
  />
  <defs>
    <linearGradient
      id="paint0_linear_9576_94306"
      x1="62.1656"
      y1="80.6186"
      x2="48.038"
      y2="63.784"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor="#9AB2BE" />
      <stop offset={1} stopColor="#6A7E88" />
    </linearGradient>
    <linearGradient
      id="paint1_linear_9576_94306"
      x1="5.41779"
      y1="80.3669"
      x2="19.5454"
      y2="63.5323"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor="#9AB2BE" />
      <stop offset="0.841346" stopColor="#717F86" />
      <stop offset={1} stopColor="#667B86" />
    </linearGradient>
    <linearGradient
      id="paint2_linear_9576_94306"
      x1="33.9798"
      y1="74.4495"
      x2="33.9798"
      y2="0.256876"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor="#6A7E88" />
      <stop offset="0.5" stopColor="#9AB2BE" />
      <stop offset={1} stopColor="#C0D5E0" />
    </linearGradient>
    <linearGradient
      id="paint3_linear_9576_94306"
      x1="24.0773"
      y1="64.5547"
      x2="43.8822"
      y2="10.1446"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor="#395665" />
      <stop offset="0.5" stopColor="#9AB2BE" />
      <stop offset={1} stopColor="#9A9EA1" />
    </linearGradient>
    <linearGradient
      id="paint4_linear_9576_94306"
      x1="33.9802"
      y1="66.2134"
      x2="33.9802"
      y2="8.49133"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0.201923" stopColor="#4D6673" />
      <stop offset={1} stopColor="#AFB0B0" />
    </linearGradient>
    <radialGradient
      id="paint5_radial_9576_94306"
      cx={0}
      cy={0}
      r={1}
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(34.0205 38.4253) scale(22.1558)"
    >
      <stop stopColor="#233640" />
      <stop offset="0.831731" stopColor="#9AB2BE" stopOpacity="0.15" />
      <stop offset="0.985577" stopColor="#8A969C" stopOpacity={0} />
    </radialGradient>
    <radialGradient
      id="paint6_radial_9576_94306"
      cx={0}
      cy={0}
      r={1}
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(58.1578 17.8983) scale(3.64979)"
    >
      <stop stopColor="white" />
      <stop offset={1} stopColor="#6A7E88" stopOpacity="0.1" />
    </radialGradient>
    <radialGradient
      id="paint7_radial_9576_94306"
      cx={0}
      cy={0}
      r={1}
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(12.4078 60.7193) rotate(-0.58) scale(1.78411 1.78412)"
    >
      <stop stopColor="white" />
      <stop offset={1} stopColor="#6A7E88" stopOpacity="0.1" />
    </radialGradient>
    <radialGradient
      id="paint8_radial_9576_94306"
      cx={0}
      cy={0}
      r={1}
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(17.2263 19.7353) rotate(-89.55) scale(2.60787 2.60787)"
    >
      <stop stopColor="white" />
      <stop offset={1} stopColor="#6A7E88" stopOpacity="0.1" />
    </radialGradient>
  </defs>
</svg>



)



export const goldMedal = (
    <svg
  width={127}
  height={126}
  viewBox="0 0 127 126"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    x="0.480957"
    width={126}
    height={126}
    rx={63}
    fill="url(#paint0_radial_9576_104927)"
  />
  <path
    d="M84.1745 107.999L87.909 97.1021L98.9811 99.5851L88.5732 81.5469L73.7666 89.961L84.1745 107.999Z"
    fill="url(#paint1_linear_9576_104927)"
  />
  <path
    d="M42.7876 107.747L39.0532 96.8501L27.981 99.3332L38.3889 81.2949L53.1955 89.709L42.7876 107.747Z"
    fill="url(#paint2_linear_9576_104927)"
  />
  <path
    d="M28.4575 40.3071V74.8786C28.4575 76.672 29.4212 78.3288 30.9857 79.2266L61.154 96.5123C62.7186 97.4101 64.6481 97.4101 66.2127 96.5123L96.381 79.2266C97.9456 78.3288 98.9092 76.672 98.9092 74.8786V40.3071C98.9092 38.5137 97.9456 36.8569 96.381 35.9591L66.2127 18.6733C64.6481 17.7756 62.7186 17.7756 61.154 18.6733L30.9857 35.9591C29.4212 36.8569 28.4575 38.5137 28.4575 40.3071Z"
    fill="url(#paint3_linear_9576_104927)"
  />
  <path
    d="M34.5928 43.8268V71.3655C34.5928 73.159 35.5564 74.8158 37.121 75.7136L61.1534 89.4819C62.7179 90.3796 64.6474 90.3796 66.212 89.4819L90.2444 75.7136C91.809 74.8158 92.7726 73.159 92.7726 71.3655V43.8268C92.7726 42.0333 91.809 40.3766 90.2444 39.4788L66.212 25.7105C64.6474 24.8127 62.7179 24.8127 61.1534 25.7105L37.121 39.4788C35.5564 40.3766 34.5928 42.0333 34.5928 43.8268Z"
    fill="url(#paint4_linear_9576_104927)"
  />
  <path
    d="M36.125 44.6987V70.4831C36.125 72.2765 37.0887 73.9333 38.6532 74.8311L61.1538 87.7233C62.7184 88.6211 64.6479 88.6211 66.2124 87.7233L88.713 74.8311C90.2776 73.9333 91.2413 72.2765 91.2413 70.4831V44.6987C91.2413 42.9053 90.2776 41.2485 88.713 40.3507L66.2124 27.4585C64.6479 26.5607 62.7184 26.5607 61.1538 27.4585L38.6532 40.3507C37.0887 41.2485 36.125 42.9053 36.125 44.6987Z"
    fill="url(#paint5_linear_9576_104927)"
  />
  <path
    d="M80.1149 75.2594C89.4199 66.025 89.42 51.0531 80.1149 41.8187C70.8099 32.5843 55.7235 32.5843 46.4185 41.8187C37.1135 51.0531 37.1135 66.025 46.4185 75.2594C55.7235 84.4939 70.8099 84.4939 80.1149 75.2594Z"
    fill="url(#paint6_radial_9576_104927)"
  />
  <path
    d="M59.4069 52.0469H46.2261L63.4801 57.6093L59.4069 52.0469Z"
    fill="#FAD974"
  />
  <path
    d="M63.479 57.6055L74.1426 72.1696L70.0694 59.7307L63.479 57.6055Z"
    fill="#F5C33F"
  />
  <path
    d="M52.8164 72.1696L63.48 64.482V57.6055L52.8164 72.1696Z"
    fill="#F5C33F"
  />
  <path
    d="M80.733 52.0469H67.5521L63.479 57.6093L80.733 52.0469Z"
    fill="#F5C33F"
  />
  <path
    d="M63.479 64.482L74.1426 72.1696L63.479 57.6055V64.482Z"
    fill="#FAD974"
  />
  <path
    d="M63.48 57.6055L56.8895 59.7307L52.8164 72.1696L63.48 57.6055Z"
    fill="#FAD974"
  />
  <path
    d="M59.4082 52.0427L63.4813 57.6051V39.6016L59.4082 52.0427Z"
    fill="#F5C33F"
  />
  <path
    d="M63.479 39.6016V57.6051L67.5521 52.0427L63.479 39.6016Z"
    fill="#FAD974"
  />
  <path
    d="M63.4801 57.6093L46.2261 52.0469L56.8896 59.7345L63.4801 57.6093Z"
    fill="#F5C33F"
  />
  <path
    d="M63.479 57.6093L70.0694 59.7345L80.733 52.0469L63.479 57.6093Z"
    fill="#FAD974"
  />
  <path
    d="M47.9915 39.156C47.9942 37.6242 46.7451 36.3802 45.2015 36.3775C43.658 36.3749 42.4045 37.6145 42.4019 39.1463C42.3992 40.6781 43.6483 41.9221 45.1918 41.9248C46.7353 41.9274 47.9888 40.6878 47.9915 39.156Z"
    fill="url(#paint7_radial_9576_104927)"
  />
  <path
    d="M45.2041 43.1219C45.2041 40.9273 43.4101 39.1469 41.1987 39.1469C43.4123 39.1469 45.2041 37.3665 45.2041 35.1719C45.2041 37.3665 46.9981 39.1469 49.2095 39.1469C46.9959 39.1469 45.2041 40.9273 45.2041 43.1219Z"
    fill="white"
  />
  <path
    d="M72.4495 86.1951C72.4518 85.1471 71.5978 84.2957 70.5418 84.2933C69.4858 84.2909 68.6278 85.1385 68.6254 86.1865C68.623 87.2344 69.4771 88.0859 70.5331 88.0883C71.5891 88.0907 72.4471 87.2431 72.4495 86.1951Z"
    fill="url(#paint8_radial_9576_104927)"
  />
  <path
    d="M70.5271 88.906C70.5271 87.4032 69.299 86.1845 67.7847 86.1845C69.299 86.1845 70.5271 84.9657 70.5271 83.4629C70.5271 84.9657 71.7551 86.1845 73.2694 86.1845C71.7551 86.1845 70.5271 87.4032 70.5271 88.906Z"
    fill="white"
  />
  <path
    d="M83.5728 40.1826C85.733 40.18 87.4821 38.4399 87.4795 36.2961C87.4768 34.1523 85.7235 32.4165 83.5633 32.4191C81.403 32.4217 79.654 34.1618 79.6566 36.3056C79.6593 38.4494 81.4126 40.1852 83.5728 40.1826Z"
    fill="url(#paint9_radial_9576_104927)"
  />
  <path
    d="M83.5727 41.8481C83.5727 38.7752 81.0619 36.2835 77.9634 36.2835C81.0619 36.2835 83.5727 33.7897 83.5727 30.7168C83.5727 33.7897 86.0834 36.2835 89.182 36.2835C86.0834 36.2835 83.5727 38.7774 83.5727 41.8503V41.8481Z"
    fill="white"
  />
  <defs>
    <radialGradient
      id="paint0_radial_9576_104927"
      cx={0}
      cy={0}
      r={1}
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(63.481 63) rotate(90) scale(63)"
    >
      <stop stopColor="#F4F3F9" />
      <stop offset={1} stopColor="white" stopOpacity="0.08" />
    </radialGradient>
    <linearGradient
      id="paint1_linear_9576_104927"
      x1="93.9854"
      y1="103.757"
      x2="78.9267"
      y2="85.6753"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor="#F8D56C" />
      <stop offset={1} stopColor="#E6990B" />
    </linearGradient>
    <linearGradient
      id="paint2_linear_9576_104927"
      x1="32.9768"
      y1="103.517"
      x2="48.0345"
      y2="85.4371"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor="#F8D56C" />
      <stop offset={1} stopColor="#E6990B" />
    </linearGradient>
    <linearGradient
      id="paint3_linear_9576_104927"
      x1="63.6845"
      y1="97.1846"
      x2="63.6845"
      y2="18.0011"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor="#F0B431" />
      <stop offset="0.5" stopColor="#F9D66D" />
      <stop offset={1} stopColor="#FAD974" />
    </linearGradient>
    <linearGradient
      id="paint4_linear_9576_104927"
      x1="53.0355"
      y1="86.6302"
      x2="74.0473"
      y2="28.4593"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor="#EDB036" />
      <stop offset="0.5" stopColor="#FBD589" />
      <stop offset={1} stopColor="#EAA724" />
    </linearGradient>
    <linearGradient
      id="paint5_linear_9576_104927"
      x1="63.6842"
      y1="88.3934"
      x2="63.6842"
      y2="26.7862"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor="#E89E12" />
      <stop offset={1} stopColor="#F4BC48" />
    </linearGradient>
    <radialGradient
      id="paint6_radial_9576_104927"
      cx={0}
      cy={0}
      r={1}
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(63.2664 58.5397) scale(23.827 23.6462)"
    >
      <stop stopColor="#CB5114" />
      <stop offset="0.841346" stopColor="#F4BC48" stopOpacity="0.33" />
      <stop offset="0.961538" stopColor="#E9A117" stopOpacity="0.13" />
    </radialGradient>
    <radialGradient
      id="paint7_radial_9576_104927"
      cx={0}
      cy={0}
      r={1}
      gradientTransform="matrix(0.00832133 -2.78329 2.80456 0.0082582 45.3611 38.4689)"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor="white" stopOpacity="0.2" />
      <stop offset={1} stopColor="#F4BC48" stopOpacity="0.2" />
    </radialGradient>
    <radialGradient
      id="paint8_radial_9576_104927"
      cx={0}
      cy={0}
      r={1}
      gradientTransform="matrix(0.00669748 -1.90412 1.91868 0.00664667 70.6502 85.7241)"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor="white" stopOpacity="0.2" />
      <stop offset={1} stopColor="#F4BC48" stopOpacity="0.2" />
    </radialGradient>
    <radialGradient
      id="paint9_radial_9576_104927"
      cx={0}
      cy={0}
      r={1}
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(84.5308 36.5264) scale(3.92508 3.89531)"
    >
      <stop stopColor="white" stopOpacity="0.2" />
      <stop offset={1} stopColor="#F4BC48" stopOpacity="0.2" />
    </radialGradient>
  </defs>
</svg>

)
export const platinumMedal = (
    <svg
  width={67}
  height={85}
  viewBox="0 0 67 85"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M52.4357 84.5839L55.9062 74.3716L66.2039 76.6981L56.5259 59.7988L42.7578 67.6826L52.4357 84.5839Z"
    fill="url(#paint0_linear_9576_104976)"
  />
  <path
    d="M13.9488 84.3417L10.4763 74.1294L0.180664 76.4559L9.85859 59.5566L23.6267 67.4404L13.9488 84.3417Z"
    fill="url(#paint1_linear_9576_104976)"
  />
  <path
    d="M0.623535 21.157V53.5494C0.623535 55.2298 1.51959 56.7822 2.97443 57.6234L31.0268 73.8196C32.4816 74.6609 34.2758 74.6609 35.7306 73.8196L63.783 57.6234C65.2378 56.7822 66.1339 55.2298 66.1339 53.5494V21.157C66.1339 19.4766 65.2378 17.9242 63.783 17.083L35.7306 0.886763C34.2758 0.0455582 32.4816 0.0455582 31.0268 0.886763L2.97443 17.083C1.51959 17.9242 0.623535 19.4766 0.623535 21.157Z"
    fill="url(#paint2_linear_9576_104976)"
  />
  <path
    d="M6.33008 24.4491V50.2522C6.33008 51.9325 7.22613 53.4849 8.68097 54.3261L31.0278 67.2266C32.4826 68.0678 34.2768 68.0678 35.7316 67.2266L58.0784 54.3261C59.5332 53.4849 60.4293 51.9325 60.4293 50.2522V24.4491C60.4293 22.7687 59.5332 21.2164 58.0784 20.3752L35.7316 7.47465C34.2768 6.63345 32.4826 6.63345 31.0278 7.47465L8.68097 20.3752C7.22613 21.2164 6.33008 22.7687 6.33008 24.4491Z"
    fill="url(#paint3_linear_9576_104976)"
  />
  <path
    d="M7.75439 25.2728V49.432C7.75439 51.1124 8.65045 52.6648 10.1053 53.506L31.0277 65.5856C32.4826 66.4268 34.2767 66.4268 35.7316 65.5856L56.654 53.506C58.1089 52.6648 59.0049 51.1124 59.0049 49.432V25.2728C59.0049 23.5924 58.1089 22.04 56.654 21.1988L35.7316 9.11919C34.2767 8.27798 32.4826 8.27798 31.0277 9.11919L10.1053 21.1988C8.65045 22.04 7.75439 23.5924 7.75439 25.2728Z"
    fill="url(#paint4_linear_9576_104976)"
  />
  <path
    d="M32.6817 59.3467C44.918 59.3467 54.8375 49.4273 54.8375 37.191C54.8375 24.9547 44.918 15.0352 32.6817 15.0352C20.4453 15.0352 10.5259 24.9547 10.5259 37.191C10.5259 49.4273 20.4453 59.3467 32.6817 59.3467Z"
    fill="url(#paint5_radial_9576_104976)"
  />
  <path
    d="M57.0971 20.9304C59.1058 20.9304 60.7342 19.302 60.7342 17.2933C60.7342 15.2846 59.1058 13.6562 57.0971 13.6562C55.0883 13.6562 53.46 15.2846 53.46 17.2933C53.46 19.302 55.0883 20.9304 57.0971 20.9304Z"
    fill="url(#paint6_radial_9576_104976)"
  />
  <path
    d="M57.0977 22.5079C57.0977 19.6287 54.7631 17.294 51.8818 17.294C54.7631 17.294 57.0977 14.9573 57.0977 12.0781C57.0977 14.9573 59.4324 17.292 62.3136 17.292C59.4324 17.292 57.0977 19.6287 57.0977 22.5079Z"
    fill="white"
  />
  <path
    d="M11.628 62.1815C12.6099 62.1713 13.3975 61.367 13.3872 60.3851C13.3769 59.4032 12.5727 58.6156 11.5908 58.6259C10.6089 58.6362 9.82132 59.4405 9.83161 60.4223C9.84189 61.4042 10.6462 62.1918 11.628 62.1815Z"
    fill="url(#paint7_radial_9576_104976)"
  />
  <path
    d="M11.5984 62.9672C11.5984 61.5591 10.4564 60.4172 9.04834 60.4172C10.4564 60.4172 11.5984 59.2753 11.5984 57.8672C11.5984 59.2753 12.7403 60.4172 14.1484 60.4172C12.7403 60.4172 11.5984 61.5591 11.5984 62.9672Z"
    fill="white"
  />
  <path
    d="M29.4033 32.1465H17.1489L33.1907 37.3603L29.4033 32.1465Z"
    fill="#D3CFDF"
  />
  <path
    d="M33.1904 37.3652L43.1061 51.0114L39.3186 39.3545L33.1904 37.3652Z"
    fill="#A39BD7"
  />
  <path
    d="M23.2769 51.0114L33.1905 43.8084V37.3652L23.2769 51.0114Z"
    fill="#A39BD7"
  />
  <path
    d="M49.2343 32.1465H36.9779L33.1904 37.3603L49.2343 32.1465Z"
    fill="#A39BD7"
  />
  <path
    d="M33.1904 43.8084L43.1061 51.0114L33.1904 37.3652V43.8084Z"
    fill="#D3CFDF"
  />
  <path
    d="M33.1905 37.3652L27.0643 39.3545L23.2769 51.0114L33.1905 37.3652Z"
    fill="#D3CFDF"
  />
  <path
    d="M29.4019 32.151L33.1893 37.3649V20.4961L29.4019 32.151Z"
    fill="#A39BD7"
  />
  <path
    d="M33.1904 20.4961V37.3649L36.9779 32.151L33.1904 20.4961Z"
    fill="#D3CFDF"
  />
  <path
    d="M33.1907 37.3603L17.1489 32.1465L27.0646 39.3496L33.1907 37.3603Z"
    fill="#A39BD7"
  />
  <path
    d="M33.1904 37.3603L39.3186 39.3496L49.2343 32.1465L33.1904 37.3603Z"
    fill="#D3CFDF"
  />
  <path
    d="M18.7783 20.0885C18.7901 18.6532 17.6361 17.4802 16.2009 17.4684C14.7657 17.4567 13.5927 18.6106 13.5809 20.0458C13.5691 21.4811 14.7231 22.6541 16.1583 22.6658C17.5935 22.6776 18.7665 21.5237 18.7783 20.0885Z"
    fill="url(#paint8_radial_9576_104976)"
  />
  <path
    d="M16.1956 23.7946C16.1956 21.7383 14.5275 20.0702 12.4712 20.0702C14.5295 20.0702 16.1956 18.402 16.1956 16.3457C16.1956 18.402 17.8638 20.0702 19.9201 20.0702C17.8618 20.0702 16.1956 21.7383 16.1956 23.7946Z"
    fill="white"
  />
  <defs>
    <linearGradient
      id="paint0_linear_9576_104976"
      x1="61.5669"
      y1="80.598"
      x2="47.4393"
      y2="63.7634"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor="#D3CFDF" />
      <stop offset="0.865385" stopColor="#A198D7" />
      <stop offset={1} stopColor="#A39BD7" />
    </linearGradient>
    <linearGradient
      id="paint1_linear_9576_104976"
      x1="4.8191"
      y1="80.3874"
      x2="18.9467"
      y2="63.5529"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor="#D3CFDF" />
      <stop offset="0.850962" stopColor="#A198D7" />
      <stop offset={1} stopColor="#A39BD7" />
    </linearGradient>
    <linearGradient
      id="paint2_linear_9576_104976"
      x1="33.3797"
      y1="74.4495"
      x2="33.3797"
      y2="0.256876"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor="#A39BD7" />
      <stop offset="0.5" stopColor="#D3CFDF" />
      <stop offset={1} stopColor="#CEBEFF" />
    </linearGradient>
    <linearGradient
      id="paint3_linear_9576_104976"
      x1="23.4773"
      y1="64.5547"
      x2="43.2821"
      y2="10.1446"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor="#6554D8" />
      <stop offset="0.5" stopColor="#B5B1D3" />
      <stop offset={1} stopColor="#7766D8" />
    </linearGradient>
    <linearGradient
      id="paint4_linear_9576_104976"
      x1="33.3786"
      y1="66.2134"
      x2="33.3786"
      y2="8.49133"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor="#3F3483" />
      <stop offset={1} stopColor="#625C87" />
    </linearGradient>
    <radialGradient
      id="paint5_radial_9576_104976"
      cx={0}
      cy={0}
      r={1}
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(32.6817 37.191) scale(22.1558 22.1558)"
    >
      <stop stopColor="#322361" />
      <stop offset="0.375" stopColor="#6D63B0" />
      <stop offset="0.971154" stopColor="#5F5598" stopOpacity={0} />
    </radialGradient>
    <radialGradient
      id="paint6_radial_9576_104976"
      cx={0}
      cy={0}
      r={1}
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(58.4163 17.8983) scale(3.6498 3.64979)"
    >
      <stop stopColor="white" stopOpacity="0.2" />
      <stop offset={1} stopColor="#A39BD7" stopOpacity="0.2" />
    </radialGradient>
    <radialGradient
      id="paint7_radial_9576_104976"
      cx={0}
      cy={0}
      r={1}
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(12.8737 61.1915) scale(1.78553 1.78553)"
    >
      <stop stopColor="white" stopOpacity="0.2" />
      <stop offset={1} stopColor="#A39BD7" stopOpacity="0.2" />
    </radialGradient>
    <radialGradient
      id="paint8_radial_9576_104976"
      cx={0}
      cy={0}
      r={1}
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(17.3684 20.699) scale(2.60591 2.6059)"
    >
      <stop stopColor="white" stopOpacity="0.2" />
      <stop offset={1} stopColor="#A39BD7" stopOpacity="0.2" />
    </radialGradient>
  </defs>
</svg>

)
export const ironMedal = (
    <svg
  width={72}
  height={90}
  viewBox="0 0 72 90"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  xmlnsXlink="http://www.w3.org/1999/xlink"
>
  <path
    d="M56.5749 89.9992L60.307 79.1021L71.3809 81.5851L60.9735 63.5469L46.1675 71.961L56.5749 89.9992Z"
    fill="url(#paint0_linear_9576_89800)"
  />
  <path
    d="M56.5749 89.9992L60.307 79.1021L71.3809 81.5851L60.9735 63.5469L46.1675 71.961L56.5749 89.9992Z"
    fill="#8E8546"
    fillOpacity="0.4"
  />
  <path
    d="M15.1868 89.7472L11.4526 78.8501L0.380859 81.3332L10.7883 63.2949L25.5943 71.709L15.1868 89.7472Z"
    fill="url(#paint1_linear_9576_89800)"
  />
  <path
    d="M15.1868 89.7472L11.4526 78.8501L0.380859 81.3332L10.7883 63.2949L25.5943 71.709L15.1868 89.7472Z"
    fill="#8E8546"
    fillOpacity="0.4"
  />
  <path
    d="M0.857422 22.3071V56.8786C0.857422 58.672 1.82102 60.3288 3.38553 61.2266L33.5525 78.5123C35.117 79.4101 37.0464 79.4101 38.6109 78.5123L68.7779 61.2266C70.3424 60.3288 71.306 58.672 71.306 56.8786V22.3071C71.306 20.5137 70.3424 18.8569 68.7779 17.9591L38.6109 0.673344C37.0464 -0.224448 35.117 -0.224448 33.5525 0.673344L3.38553 17.9591C1.82102 18.8569 0.857422 20.5137 0.857422 22.3071Z"
    fill="url(#paint2_linear_9576_89800)"
  />
  <path
    d="M0.857422 22.3071V56.8786C0.857422 58.672 1.82102 60.3288 3.38553 61.2266L33.5525 78.5123C35.117 79.4101 37.0464 79.4101 38.6109 78.5123L68.7779 61.2266C70.3424 60.3288 71.306 58.672 71.306 56.8786V22.3071C71.306 20.5137 70.3424 18.8569 68.7779 17.9591L38.6109 0.673344C37.0464 -0.224448 35.117 -0.224448 33.5525 0.673344L3.38553 17.9591C1.82102 18.8569 0.857422 20.5137 0.857422 22.3071Z"
    fill="#8E8546"
    fillOpacity="0.4"
  />
  <path d="M0.857422 22.3071V56.8786C0.857422 58.672 1.82102 60.3288 3.38553 61.2266L33.5525 78.5123C35.117 79.4101 37.0464 79.4101 38.6109 78.5123L68.7779 61.2266C70.3424 60.3288 71.306 58.672 71.306 56.8786V22.3071C71.306 20.5137 70.3424 18.8569 68.7779 17.9591L38.6109 0.673344C37.0464 -0.224448 35.117 -0.224448 33.5525 0.673344L3.38553 17.9591C1.82102 18.8569 0.857422 20.5137 0.857422 22.3071Z" />
  <path
    d="M0.857422 22.3071V56.8786C0.857422 58.672 1.82102 60.3288 3.38553 61.2266L33.5525 78.5123C35.117 79.4101 37.0464 79.4101 38.6109 78.5123L68.7779 61.2266C70.3424 60.3288 71.306 58.672 71.306 56.8786V22.3071C71.306 20.5137 70.3424 18.8569 68.7779 17.9591L38.6109 0.673344C37.0464 -0.224448 35.117 -0.224448 33.5525 0.673344L3.38553 17.9591C1.82102 18.8569 0.857422 20.5137 0.857422 22.3071Z"
    fill="url(#paint3_linear_9576_89800)"
  />
  <path
    d="M0.857422 22.3071V56.8786C0.857422 58.672 1.82102 60.3288 3.38553 61.2266L33.5525 78.5123C35.117 79.4101 37.0464 79.4101 38.6109 78.5123L68.7779 61.2266C70.3424 60.3288 71.306 58.672 71.306 56.8786V22.3071C71.306 20.5137 70.3424 18.8569 68.7779 17.9591L38.6109 0.673344C37.0464 -0.224448 35.117 -0.224448 33.5525 0.673344L3.38553 17.9591C1.82102 18.8569 0.857422 20.5137 0.857422 22.3071Z"
    fill="#8E8546"
    fillOpacity="0.4"
  />
  <path d="M0.857422 22.3071V56.8786C0.857422 58.672 1.82102 60.3288 3.38553 61.2266L33.5525 78.5123C35.117 79.4101 37.0464 79.4101 38.6109 78.5123L68.7779 61.2266C70.3424 60.3288 71.306 58.672 71.306 56.8786V22.3071C71.306 20.5137 70.3424 18.8569 68.7779 17.9591L38.6109 0.673344C37.0464 -0.224448 35.117 -0.224448 33.5525 0.673344L3.38553 17.9591C1.82102 18.8569 0.857422 20.5137 0.857422 22.3071Z" />
  <path
    d="M6.99414 25.8268V53.3655C6.99414 55.159 7.95774 56.8158 9.52225 57.7136L33.5536 71.4819C35.1181 72.3796 37.0475 72.3796 38.612 71.4819L62.6433 57.7136C64.2078 56.8158 65.1714 55.159 65.1714 53.3655V25.8268C65.1714 24.0333 64.2078 22.3766 62.6433 21.4788L38.612 7.71045C37.0475 6.81266 35.1181 6.81266 33.5536 7.71045L9.52225 21.4788C7.95774 22.3766 6.99414 24.0333 6.99414 25.8268Z"
    fill="url(#paint4_linear_9576_89800)"
  />
  <path
    d="M8.52588 26.6987V52.4831C8.52588 54.2765 9.48948 55.9333 11.054 56.8311L33.5536 69.7233C35.1181 70.6211 37.0475 70.6211 38.612 69.7233L61.1116 56.8311C62.6761 55.9333 63.6397 54.2765 63.6397 52.4831V26.6987C63.6397 24.9053 62.6761 23.2485 61.1116 22.3507L38.612 9.4585C37.0475 8.56071 35.1181 8.56071 33.5536 9.4585L11.054 22.3507C9.48948 23.2485 8.52588 24.9053 8.52588 26.6987Z"
    fill="url(#paint5_linear_9576_89800)"
  />
  <path
    d="M52.9472 56.4704C62.2518 47.236 62.2518 32.264 52.9472 23.0296C43.6426 13.7952 28.5568 13.7952 19.2522 23.0296C9.94764 32.264 9.94766 47.236 19.2523 56.4704C28.5569 65.7048 43.6426 65.7048 52.9472 56.4704Z"
    fill="url(#paint6_radial_9576_89800)"
  />
  <path
    d="M31.6566 33.5391H18.4785L35.7296 39.1015L31.6566 33.5391Z"
    fill="#60351E"
  />
  <path
    d="M31.6566 33.5391H18.4785L35.7296 39.1015L31.6566 33.5391Z"
    fill="#8E8546"
    fillOpacity="0.4"
  />
  <path
    d="M35.8789 39.6055L46.542 54.1696L42.4691 41.7307L35.8789 39.6055Z"
    fill="#CA835D"
  />
  <path
    d="M35.8789 39.6055L46.542 54.1696L42.4691 41.7307L35.8789 39.6055Z"
    fill="#8E8546"
    fillOpacity="0.4"
  />
  <path
    d="M25.2178 54.1696L35.8787 46.482V39.6055L25.2178 54.1696Z"
    fill="#CA835D"
  />
  <path
    d="M25.2178 54.1696L35.8787 46.482V39.6055L25.2178 54.1696Z"
    fill="#8E8546"
    fillOpacity="0.4"
  />
  <path
    d="M53.1322 34.0469H39.9519L35.8789 39.6093L53.1322 34.0469Z"
    fill="#CA835D"
  />
  <path
    d="M53.1322 34.0469H39.9519L35.8789 39.6093L53.1322 34.0469Z"
    fill="#8E8546"
    fillOpacity="0.4"
  />
  <path
    d="M35.7295 45.9742L46.3926 53.6618L35.7295 39.0977V45.9742Z"
    fill="#60351E"
  />
  <path
    d="M35.7295 45.9742L46.3926 53.6618L35.7295 39.0977V45.9742Z"
    fill="#8E8546"
    fillOpacity="0.4"
  />
  <path
    d="M35.7293 39.0977L29.1413 41.2229L25.0684 53.6618L35.7293 39.0977Z"
    fill="#60351E"
  />
  <path
    d="M35.7293 39.0977L29.1413 41.2229L25.0684 53.6618L35.7293 39.0977Z"
    fill="#8E8546"
    fillOpacity="0.4"
  />
  <path
    d="M31.8047 34.0427L35.8776 39.6051V21.6016L31.8047 34.0427Z"
    fill="#CA835D"
  />
  <path
    d="M31.8047 34.0427L35.8776 39.6051V21.6016L31.8047 34.0427Z"
    fill="#8E8546"
    fillOpacity="0.4"
  />
  <path
    d="M35.7295 21.0938V39.0973L39.8025 33.5349L35.7295 21.0938Z"
    fill="#60351E"
  />
  <path
    d="M35.7295 21.0938V39.0973L39.8025 33.5349L35.7295 21.0938Z"
    fill="#8E8546"
    fillOpacity="0.4"
  />
  <path
    d="M35.879 39.6093L18.6279 34.0469L29.291 41.7345L35.879 39.6093Z"
    fill="#CA835D"
  />
  <path
    d="M35.879 39.6093L18.6279 34.0469L29.291 41.7345L35.879 39.6093Z"
    fill="#8E8546"
    fillOpacity="0.4"
  />
  <path
    d="M35.8789 39.6093L42.4691 41.7345L53.1322 34.0469L35.8789 39.6093Z"
    fill="#60351E"
  />
  <path
    d="M35.8789 39.6093L42.4691 41.7345L53.1322 34.0469L35.8789 39.6093Z"
    fill="#8E8546"
    fillOpacity="0.4"
  />
  <defs>
    <linearGradient
      id="paint0_linear_9576_89800"
      x1="66.385"
      y1="85.7462"
      x2="51.3262"
      y2="67.665"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor="#CA835D" />
      <stop offset={1} stopColor="#651B1B" />
    </linearGradient>
    <linearGradient
      id="paint1_linear_9576_89800"
      x1="5.37835"
      y1="85.528"
      x2="20.4361"
      y2="67.4487"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor="#CA835D" />
      <stop offset="0.846154" stopColor="#80372C" />
      <stop offset={1} stopColor="#651B1B" />
    </linearGradient>
    <linearGradient
      id="paint2_linear_9576_89800"
      x1="36.0828"
      y1="79.1846"
      x2="36.0828"
      y2="0.00108553"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor="#BA693D" />
      <stop offset="0.163462" stopColor="white" />
      <stop offset="0.5" stopColor="#CA835D" />
      <stop offset="0.783654" stopColor="#FFFEFD" />
      <stop offset={1} stopColor="#C5754A" />
    </linearGradient>
    <linearGradient
      id="paint3_linear_9576_89800"
      x1="36.0828"
      y1="79.1846"
      x2="36.0828"
      y2="0.00108553"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor="#BA693D" />
      <stop offset="0.163462" stopColor="white" stopOpacity="0.09" />
      <stop offset="0.5" stopColor="#CA835D" />
      <stop offset="0.783654" stopColor="#FFFEFD" stopOpacity="0.35" />
      <stop offset={1} stopColor="#C5754A" />
    </linearGradient>
    <linearGradient
      id="paint4_linear_9576_89800"
      x1="25.4339"
      y1="68.6302"
      x2="46.4485"
      y2="10.4598"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor="#CA835D" />
      <stop offset="0.649038" stopColor="#8E8546" stopOpacity="0.28" />
      <stop offset={1} stopColor="#BA693D" />
    </linearGradient>
    <linearGradient
      id="paint5_linear_9576_89800"
      x1="36.0817"
      y1="70.3934"
      x2="36.0817"
      y2="8.78624"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor="#8B7D43" stopOpacity="0.48" />
      <stop offset="0.0001" stopColor="#543929" />
      <stop offset="0.9996" stopColor="#847065" />
      <stop offset="0.9997" stopColor="#897841" stopOpacity="0.169173" />
      <stop offset="0.9998" stopColor="#8E8546" stopOpacity="0.05" />
    </linearGradient>
    <radialGradient
      id="paint6_radial_9576_89800"
      cx={0}
      cy={0}
      r={1}
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(36.1001 39.7506) scale(23.8259 23.6462)"
    >
      <stop stopColor="#65451B" />
      <stop offset={1} stopColor="#CA835D" stopOpacity="0.06" />
    </radialGradient>
  </defs>
</svg>

)